export const definedTags = [];

export function defineElement(tagName, ctor) {
  definedTags.push(tagName);
  customElements.define(tagName, ctor);
}
